import { render } from "./File.vue?vue&type=template&id=fa26082c&ts=true"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__